export default "__VITE_ASSET__BH5EgQCT__"